import axios from 'axios'

const chat = {
  namespaced: true,

  state: {
    rooms: [],
    messages: [],
    loading: false
  },

  getters: {
    messagesByRoomId: state => roomId => {
      return state.messages.filter(msg => msg.chat_room_id === roomId)
    },

    chatRoomById: state => roomId => {
      return state.rooms.find(room => room.id === roomId)
    }
  },

  mutations: {
    setLoading (state, loading) {
      state.loading = loading
    },

    setMessages (state, messages) {
      state.messages = messages
    },

    addMessage (state, message) {
      state.messages.push(message)
    },

    removeMessage (state, message) {
      const idx = state.messages.findIndex(item => item.id === message.id)
      state.messages.splice(idx, 1)
    },

    setRooms (state, rooms) {
      state.rooms = rooms
    }
  },

  actions: {
    getMessage ({ commit }) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        axios.get('/chat')
          .then(response => {
            commit('setMessages', response.data)
            commit('setLoading', false)
            resolve()
          })
          .catch(err => {
            reject(err)
          })
      })
    }
  }
}

export default chat
